import {cdmMw} from '../api';

export default {
    api: cdmMw,
    url: 'api/opra-exchanges',
    parseResponse: ({data}) => data || [],
    defaultValue: [],
    useCache: true
};
